import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import Tooltip from '@spark/ui-components/components/Tooltip';
import { formatarDataSimples } from '@spark/utils/formatters';

export const getTabelaVeiculoColumns = (onEdit, onDelete, loadingEditId, loadingDeleteId) => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    size: 80,
    cell: ({ row }) => row.original.id ?? '-'
  },
  {
    id: 'numeroFrota',
    accessorKey: 'numeroFrota',
    header: 'Numero Frota',
    size: 140,
    cell: ({ row }) => row.original.numeroFrota || '-'
  },
  {
    id: 'idTabelaPremiacao',
    accessorKey: 'idTabelaPremiacao',
    header: 'Id Tabela',
    size: 100,
    cell: ({ row }) => row.original.idTabelaPremiacao ?? '-'
  },
  {
    id: 'nomeTabelaPremiacao',
    accessorKey: 'nomeTabelaPremiacao',
    header: 'Nome Tabela',
    size: 200,
    cell: ({ row }) => row.original.nomeTabelaPremiacao || '-'
  },
  {
    id: 'ativo',
    accessorKey: 'ativo',
    header: 'Ativo',
    size: 80,
    cell: ({ row }) => (row.original.ativo === true ? 'Sim' : 'Nao')
  },
  {
    id: 'data',
    accessorKey: 'data',
    header: 'Data',
    size: 130,
    cell: ({ row }) => (row.original.data ? formatarDataSimples(row.original.data) : '-')
  },
  {
    id: 'acoes',
    header: 'Acoes',
    size: 120,
    cell: ({ row }) => (
      <div style={{ display: 'flex', gap: 8 }}>
        <Tooltip dir="top" text="Editar">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-primary"
              size="sm"
              loading={loadingEditId === row.original.id}
              disabled={loadingEditId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onEdit(row.original.id);
              }}
            >
              <Icon name="pencil" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
        <Tooltip dir="top" text="Excluir">
          <span className="d-inline-block">
            <ButtonWithLoading
              variant="outline-danger"
              size="sm"
              loading={loadingDeleteId === row.original.id}
              disabled={loadingDeleteId === row.original.id}
              onClick={(event) => {
                event.stopPropagation();
                onDelete(row.original.id);
              }}
            >
              <Icon name="trash" size={16} />
            </ButtonWithLoading>
          </span>
        </Tooltip>
      </div>
    ),
    enableSorting: false
  }
];
